import { render, staticRenderFns } from "./info.vue?vue&type=template&id=423d10b2&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d10b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423d10b2')) {
      api.createRecord('423d10b2', component.options)
    } else {
      api.reload('423d10b2', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=423d10b2&scoped=true", function () {
      api.rerender('423d10b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/info.vue"
export default component.exports